import React from "react";
import { useTranslation } from "react-i18next";
import {
    InputRow,
    SwitchRow,
    DetailRow,
    SelectRow,
} from "../Rows";
import { FormCard, FormGrid } from "../FormCard";
import {
    OCPP_VERSION_OPTIONS,
    generateBasicAuthPassword,
    isOcpp201,
    toBasicAuthPasswordInput,
} from "./ocppPointHelpers";

const EditPointDetails = ({
    chargingPoint = {},
    handleInputChange,
    handleSupportsReservationChange,
    invalidFields,
}) => {
    const { t } = useTranslation();
    const handleOcppVersionChange = (v) => {
        if (!v) {
            return;
        }
        const switchingTo201 = isOcpp201(v) && !isOcpp201(chargingPoint.ocppVersion);
        handleInputChange("ocppVersion", v);
        if (switchingTo201) {
            handleInputChange("basicAuthPassword", generateBasicAuthPassword());
        } else if (!isOcpp201(v)) {
            handleInputChange("basicAuthPassword", "");
        }
    };

    return (
        <FormCard title={t("form.chargingPointDetails")}>
            <FormGrid>

                <InputRow
                    label={t("common.name")}
                    value={chargingPoint.chargingPointName}
                    invalid={invalidFields?.includes("chargingPointName")}
                    onChange={(v) => handleInputChange("chargingPointName", v)}
                />
                <InputRow
                    label={t("form.ocppConnectionId")}
                    value={chargingPoint.chargingPointConnectionId}
                    invalid={invalidFields?.includes("chargingPointConnectionId")}
                    onChange={(v) => handleInputChange("chargingPointConnectionId", v)}
                />
                <DetailRow
                    label={t("form.multiConnectorPoint")}
                    tooltip={t("point.tooltip.multiConnector")}
                    value={chargingPoint?.isMultiStationChargingPoint ? t("common.yes") : t("common.no")}
                />
                <SwitchRow
                    label={t("form.supportsReservation")}
                    tooltip={t("point.tooltip.supportsReservation")}
                    checked={!!chargingPoint?.supportsReservation}
                    onChange={(v) => handleSupportsReservationChange(v)}
                />

                <DetailRow label={t("entity.site")} value={chargingPoint.chargingSiteName} />
                <DetailRow label={t("common.vendor")} value={chargingPoint.chargingPointVendor} />
                <DetailRow label={t("common.model")} value={chargingPoint.chargingPointModel} />
                <SelectRow
                    label={t("form.ocppVersion")}
                    value={chargingPoint.ocppVersion || ""}
                    options={OCPP_VERSION_OPTIONS}
                    onChange={handleOcppVersionChange}
                    required
                    isClearable={false}
                    invalid={invalidFields?.includes("ocppVersion")}
                />
                {isOcpp201(chargingPoint.ocppVersion) && (
                    <InputRow
                        label={t("form.basicAuthPassword")}
                        tooltip={t("point.tooltip.basicAuthKeep")}
                        value={chargingPoint.basicAuthPassword || ""}
                        onChange={(v) =>
                            handleInputChange("basicAuthPassword", toBasicAuthPasswordInput(v))
                        }
                        invalid={invalidFields?.includes("basicAuthPassword")}
                        maxLength={64}
                    />
                )}
                <DetailRow label={t("common.protocol")} value={chargingPoint.protocolType} />
                <DetailRow label={t("form.chargingBoxSerial")} value={chargingPoint.chargingBoxSerialNumber} />
                <DetailRow label={t("form.chargingPointSerial")} value={chargingPoint.chargingPointSerialNumber} />
                <DetailRow label={t("form.version")} value={chargingPoint.chargingPointVersion} />
                <DetailRow label={t("form.firmwareVersion")} value={chargingPoint.firmwareVersion} />
                <DetailRow label={t("form.iccid")} value={chargingPoint.iccid} />
                <DetailRow label={t("form.imsi")} value={chargingPoint.imsi} />
                <DetailRow label={t("form.meterSerial")} value={chargingPoint.meterSerialNumber} />
                <DetailRow label={t("form.meterType")} value={chargingPoint.meterType} />

            </FormGrid>
        </FormCard>
    );
};



export default EditPointDetails;
